import {AssignmentTurnedIn} from "@mui/icons-material";
import {Badge} from "@mui/material";
import React, {useEffect, useState} from "react";
import {getTODOCount} from "../services/dataService";

function ToDoCountBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    async function getCount() {
      const resp = await getTODOCount();
      setCount(resp.data[0]["TotalCount"]);
    }
    getCount();
    let interval = setInterval(async () => {
      getCount();
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <Badge badgeContent={count} sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }} color="error">
        <AssignmentTurnedIn color="info" fontSize="small"/>
      </Badge>
    </>
  );
}

export default ToDoCountBadge;
